import type { ThemeDefinition } from './types';

export const bankingClassic: ThemeDefinition = {
  id: 'banking-classic',
  name: 'Banking Classic',
  description: 'Traditional banking aesthetic — navy and gold, serif headings, formal tone',
  mode: 'light',
  tokens: {
    colorPrimary: '#1B2A4A',
    colorSecondary: '#B8860B',
    colorAccent: '#DAA520',
    colorSuccess: '#2E7D32',
    colorWarning: '#E65100',
    colorError: '#B71C1C',
    colorInfo: '#1565C0',
    colorBgBase: '#F8F6F3',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FAFAF8',
    colorBgSidebar: '#1B2A4A',
    colorText: '#1A1A2E',
    colorTextSecondary: '#4A4A5A',
    colorTextTertiary: '#7A7A8A',
    colorBorder: '#D4CFC7',
    colorBorderSecondary: '#E8E4DD',
    boxShadow: '0 1px 3px rgba(27,42,74,0.08), 0 4px 12px rgba(27,42,74,0.06)',
    boxShadowSecondary: '0 4px 16px rgba(27,42,74,0.10), 0 8px 24px rgba(27,42,74,0.08)',
    glassBlur: '12px',
    glassOpacity: '0.45',
    glassSaturation: '130%',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontFamilyHeading: '"Georgia", "Times New Roman", serif',
    fontSize: 14,
    fontSizeHeading: 20,
    borderRadius: 6,
    borderRadiusLG: 12,
    cardBorder: '#D4CFC7',
    cardShadow: '0 2px 8px rgba(27,42,74,0.06)',
  },
};
